exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1QU_k h2{margin-top:0;font-size:1.2em}", ""]);

// exports
exports.locals = {
	"filter": "_1QU_k"
};